import { useTranslation } from "react-i18next";
import CustomSelect from "../Forms/Element/CustomSelect";

const YesNoSelect = (props) => {

    const { t } = useTranslation();
    const options = [
        { value: "Y", label: t('yes') },
        { value: "N", label: t('no') }
    ];

    return (
        <CustomSelect
            placeholder={t('select')}
            options={options}
            {...props}
        />
    );
}

export default YesNoSelect;